const frontendURL = '/cat/district/';
const backendURL = '/api/references/district/';
const name = 'Райони області';

const instance = {
  frontendURL,
  backendURL,
  name,
  useHierarchyPagination: true,
};
export default instance;
